import { render, staticRenderFns } from "./StoryGame.vue?vue&type=template&id=2339a2ea&"
import script from "./StoryGame.vue?vue&type=script&lang=js&"
export * from "./StoryGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports